var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgGridWrapper',{ref:"agGrid",attrs:{"title":"Subscriptions (read)","options":_vm.gridOptions},on:{"selectedRows":function($event){return _vm.$emit('select', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }